// eslint-disable-next-line import/prefer-default-export
export const setLang = lang => dispatch => {
  dispatch({
    type: "SET_LANG",
    payload: lang
  });
};
export const setSubscriber = subscriberkey => dispatch => {
  dispatch({
    type: "SET_SUBSCRIBER",
    payload: subscriberkey
  });
};
export const toggleLangDropdown = bool => dispatch => {
  dispatch({
    type: "LANG_DROPDOWN",
    payload: bool
  });
};
export const setData = (key, value) => dispatch => {
  dispatch({
    type: "SET_DATA",
    payload: { key, value }
  });
};

export const submitForm = bool => dispatch => {
  dispatch({
    type: "SUBMIT",
    payload: bool
  });
};
